import React, { useEffect, useState } from "react";

export const EmailSuggestion = ({ suggestions, onClick, callback }) => {
  const [wrapperRef, setWrapperRef] = useState(null);

  useEffect(() => {
    if (!suggestions || !suggestions.length) return

    const onClickOutSide = (e) => {
      if (!wrapperRef) return;
      const path = e.path || (e.composedPath && e.composedPath());
      if (!path.includes(wrapperRef)) {
        callback && callback(false);
      }
    };
    window.addEventListener("mousedown", onClickOutSide);
    return () => {
      window.removeEventListener("mousedown", onClickOutSide);
    };
  }, [callback, wrapperRef]);

  if (!suggestions || !suggestions.length) return null;

  return (
    <div className="cu-suggestion" ref={(r) => setWrapperRef(r)}>
      <ul className="cu-suggestion__list">
        {suggestions.map((item, key) => (
          <li
            key={key}
            className="cu-suggestion__item"
            onClick={() => onClick(item)}
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};
